module.exports = __webpack_public_path__ + "img/nature-10.606e7eb7.jpg";